// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__11D6-","label":"SetPasswdForm_label__1IJDg"};